<form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()" class="w-full">
  <div class="flex flex-col md:flex-row items-start justify-center gap-2">
    <hlm-form-field class="w-full md:w-80 text-left">
      <input hlmInput type="email" formControlName="email" placeholder="Enter your email" class="w-full" />
      <hlm-error>
        @if (emailControl.errors?.['required']) {
          Email is required
        } @else if (emailControl.errors?.['email']) {
          Please enter a valid email address
        }
      </hlm-error>
    </hlm-form-field>
    <button
      hlmBtn
      type="submit"
      [disabled]="isSubmitting"
      class="w-full md:w-auto whitespace-nowrap"
      [class.opacity-50]="isSubmitting"
    >
      {{ isSubmitting ? 'Subscribing...' : 'Subscribe' }}
    </button>
  </div>
</form>
